export default "__VITE_ASSET__6bc8df1b__"